export default "__VITE_ASSET__DdaNTwNa__"